export type ClassValue =
  | string
  | number
  | null
  | undefined
  | false
  | ClassValue[]
  | { [key: string]: boolean | null | undefined };

/**
 * Conditional class joiner. Deliberately not a Tailwind class merger: there is
 * no tailwind-merge in this workspace, so component styles are written so that
 * a caller's `className` is appended last and only ever *adds* utilities. When a
 * component needs an overridable slot it exposes an explicit prop instead.
 */
export function cn(...inputs: ClassValue[]): string {
  const out: string[] = [];
  for (const input of inputs) {
    if (!input) continue;
    if (typeof input === 'string' || typeof input === 'number') {
      out.push(String(input));
      continue;
    }
    if (Array.isArray(input)) {
      const nested = cn(...input);
      if (nested) out.push(nested);
      continue;
    }
    for (const key of Object.keys(input)) {
      if (input[key]) out.push(key);
    }
  }
  return out.join(' ');
}
